module.exports = __webpack_public_path__ + "img/1487755503.1d823b38.jpg";